import { render, staticRenderFns } from "./DistributionChart.vue?vue&type=template&id=e821b66c&scoped=true&"
import script from "./DistributionChart.vue?vue&type=script&lang=js&"
export * from "./DistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./DistributionChart.vue?vue&type=style&index=0&id=e821b66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e821b66c",
  null
  
)

export default component.exports